"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsiveProps = require("../../internal/responsiveProps");
var _formatting = require("../../internal/formatting");
var _ = require("../../");
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledButtonGroup = (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(_.Wrapper, _extends({
  omitProps: {
    keys: ['gap', 'align', 'leftToRight'],
    responsiveKeys: ['horizontal']
  },
  noTrim: true
}, props))).withConfig({
  displayName: "StyledButtonGroup",
  componentId: "sc-uvgmit-0"
})(["display:flex;flex-wrap:wrap;flex-direction:column;", " --plain-button-flush-horizontal-boolean:0;--plain-button-flush-vertical-boolean:1;", " justify-content:", ";"], _ref => {
  let {
    gap
  } = _ref;
  return `
    gap: ${(0, _formatting.formatGtrValues)(gap)}};
  `;
}, props => (0, _responsiveProps.responsiveCssProps)({
  props: props,
  propName: 'horizontal',
  output: v => v && `
        flex-direction: ${props.leftToRight ? 'row' : 'row-reverse'};

        > * {
          --plain-button-flush-horizontal-boolean: 1;
          --plain-button-flush-vertical-boolean: 0;
        }
      `
}), _ref2 => {
  let {
    align,
    leftToRight
  } = _ref2;
  return align ? leftToRight ? _constants.ALIGN_JUSTIFY_CONTENT_LTR[align] : _constants.ALIGN_JUSTIFY_CONTENT[align] : 'space-between';
});

/**
## Usage

```jsx
import { ButtonGroup } from '@farewill/ui'
```

## Notes

`<ButtonGroup>` extends from `<Wrapper>` so can use any of `<Wrapper>`’s styling functionality.
 */
const ButtonGroup = props => /*#__PURE__*/_react.default.createElement(StyledButtonGroup, props);
exports.ButtonGroup = ButtonGroup;
ButtonGroup.defaultProps = {
  gap: [12, 'M']
};